import React, { Component } from 'react'
import gql from 'graphql-tag'
import { graphql } from 'react-apollo'

class Toaster extends Component {
  render() {
    const props = this.props
    console.log({ props })
    if (!props.data.toaster) {
      return <p>Loading...</p>
    }
    return <p>Toaster</p>
  }
}
const GetToasterBySlug = gql`
  query getToasterBySlug($slug: String) {
    toaster: toasterBy(uri: $slug) {
      title
      toasterMeta {
        price
        wattage
      }
    }
  }
`
export default graphql(GetToasterBySlug, {
  options: props => {
    const slug = props.match.params.slug
    console.log(`Slug is: ${slug}`)
    return {
      variables: {
        slug,
      },
    }
  },
})(Toaster)
